import _each from "lodash/each";
import _shuffle from "lodash/shuffle";
import store from "~/js/store/store";
import { gsap, Quint, Circ, Cubic } from "gsap";
import Common from "~/js/common/common";
export default class Menu {
  constructor() {
    this.view = document.querySelector(".p-menu");
    this.body = document.querySelector("body");
    this.menus = this.view.querySelectorAll(".js-menu");
    this.closeMenu = document.querySelector(".js-menu-close");
    this.selectedBrand = null;
    this.isOpening = false;
    this.currentRollIndex = 0;
    if (!this.view) {
      return;
    }
    this.setup();
    this.setupSubnavi();
    this.setupMenuContent();
    this.setupBrandLogo();
    this.closeMenuModal();
  }

  // setup ========================================
  setup() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "toggleNavi" || mutation.type === "closeNavi") {
        this.toggleNavi(state);
      }
    });
  }

  // サブナビ開閉
  setupSubnavi() {
    const toggleButtons = this.view.querySelectorAll(".js-menutoggle");
    _each(toggleButtons, (elm, index) => {
      let target = elm.getAttribute("data-target");
      if (!target) {
        return;
      }
      let targetElm = this.view.querySelector(target);
      this.setupSubnaviContents(targetElm);
      elm.addEventListener("keydown", (event) => {
        if (target && (event.keyCode === 13 || event.keyCode === 32 || event.code === "Enter" || event.code === "Space")) {
          this.toggleSubnaviOpen(targetElm, elm);
        }
      });
      elm.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (target) {
          this.toggleSubnaviOpen(targetElm, elm);
        }
      });
    });
  }

  setupMenuContent() {
    const contents = this.view.querySelector(".js-menucontent");
    if (contents) {
      contents.addEventListener("scroll", (event) => {
        store.dispatch("scrollInNavi", {
          y: contents.scrollTop
        });
      });
    }
  }

  // ブランドロゴとイメージ写真
  setupBrandLogo() {
    const logos = this.view.querySelectorAll(".js-menu-brandlogo");
    const images = this.view.querySelectorAll(".js-brand-images img");
    const buttonPlayPause = this.view.querySelector('.js-menu-images-play-pause-button')
    this.brandPhotos = _shuffle(images);
    this.brandPhotos[0].classList.add("active");
    _each(logos, (logo, index) => {
      logo.addEventListener("mouseover", (event) => {
        handleFocusLogo(logo, event);
      });
      logo.addEventListener("focus", (event) => {
        handleFocusLogo(logo, event);
      });
      logo.addEventListener("mouseout", (event) => {
        this.selectedBrand = null;
      });
    });

    buttonPlayPause.addEventListener("click", (event) => {
      if (buttonPlayPause.classList.contains("is-pause")) {
        buttonPlayPause.classList.remove("is-pause");
        this.startAutoRoll();
      } else {
        buttonPlayPause.classList.add("is-pause");
        this.stopAutoRoll();
      }
    });

    const handleFocusLogo = (logo, event) => {
      let brandName = logo.getAttribute("data-brand");
      if (brandName) {
        this.selectedBrand = brandName;
        this.changeBrand(brandName);
      }
    }
  }

  changeBrand(brandName) {
    const images = this.view.querySelectorAll(".js-brand-images img");
    _each(images, (img, index) => {
      img.classList.remove("active");
      if (img.className.search(brandName) !== -1) {
        img.classList.add("active");
      }
    });
  }

  setupSubnaviContents(elm) {
    let links = elm.querySelectorAll("a");
    gsap.set(links, {
      opacity: 0
    });
  }

  closeMenuModal() {
    this.closeMenu.addEventListener("click", (event) => {
      if (store.getters["isModalOpen"]()) {
        store.dispatch("closeNavi");
        store.dispatch("closeModal");
      }
    })

    this.closeMenu.addEventListener("keydown", (event) => {
      if (event.keyCode === 13 || event.keyCode === 32 || event.code === "Enter" || event.code === "Space") {
        store.dispatch("closeNavi");
        store.dispatch("closeModal");
      }
    });
  }

  // Brand Photos ========================================
  startAutoRoll() {
    if (this.autoRoll) {
      return;
    }
    this.autoRoll = gsap.delayedCall(4, () => {
      this.updateRoll();
    });
  }
  stopAutoRoll() {
    if (this.autoRoll) {
      this.autoRoll.kill();
      this.autoRoll = null;
    }
  }
  updateRoll() {
    this.stopAutoRoll();
    if (!this.brandPhotos) {
      return;
    }
    this.currentRollIndex += 1;
    if (this.currentRollIndex >= this.brandPhotos.length - 1) {
      this.currentRollIndex = 0;
    }
    const nextPhoto = this.brandPhotos[this.currentRollIndex];
    let brandName = nextPhoto.className;
    if (brandName && !this.selectedBrand) {
      this.changeBrand(brandName.replace(" active", ""));
    }
    this.startAutoRoll();
  }

  // Navi ========================================
  toggleNavi(state) {
    if (state.app.naviOpened) {
      // 開いた
      gsap.fromTo(
        this.menus,
        {
          x: -80
        },
        {
          x: 0,
          duration: 0.7,
          ease: Cubic.easeOut,
          stagger: 0.08
        }
      );
      this.body.classList.add("menu-open");
      if (this.closeTween) {
        this.closeTween.kill();
      }
      this.view.classList.add("opened");
      this.startAutoRoll();
      gsap.to(window, {
        duration: 0,
        scrollTo: {
          y: ".l-header"
        }
      });
      Common.toggleTabIndexActivate(false);
    } else {
      // 閉じた
      this.stopAutoRoll();
      this.selectedBrand = null;
      gsap.to(this.menus, {
        x: -80,
        duration: 0.3,
        ease: Quint.easeOut,
        stagger: 0.04
      });
      this.body.classList.remove("menu-open");
      this.closeTween = gsap.delayedCall(0.5, () => {
        this.view.classList.remove("opened");
      });
      Common.toggleTabIndexActivate(true);
    }
  }

  // Toggle Subnavi Open
  toggleSubnaviOpen(target, button, toOpen) {
    if (!target || this.isOpening) {
      return;
    }
    this.isOpening = true;
    let isOpen = target.classList.toggle("open");
    let links = target.querySelectorAll("a");
    gsap.delayedCall(0.2, () => {
      this.isOpening = false;
    });
    if (toOpen && !isOpen) {
      isOpen = target.classList.toggle("open");
      return;
    }
    if (isOpen) {
      button.classList.add("open");
      button.setAttribute('aria-expanded', 'true');
      target.setAttribute('aria-hidden', 'false');
      // Only set tabindex on desktop, remove it on mobile
      if (Common.isSPSize()) {
        target.removeAttribute('tabindex');
      } else {
        target.setAttribute('tabindex', '0');
      }
      _each(links, (elm, index) => {
        // Only set tabindex on desktop, remove it on mobile
        if (Common.isSPSize()) {
          elm.removeAttribute('tabindex');
        } else {
          elm.setAttribute('tabindex', '0');
        }
        gsap.fromTo(
          elm,
          {
            opacity: 0
          },
          {
            opacity: 1,
            duration: 0.5,
            delay: 0.06 * index,
            ease: Cubic.easeOut
          }
        );
      });
    } else {
      button.setAttribute('aria-expanded', 'false');
      button.classList.remove("open");
      target.setAttribute('aria-hidden', 'true');
      target.setAttribute('tabindex', '-1');
      _each(links, (elm, index) => {
        // Remove tabindex on mobile, set to -1 on desktop
        if (Common.isSPSize()) {
          elm.removeAttribute('tabindex');
        } else {
          elm.setAttribute('tabindex', '-1');
        }
        gsap.set(elm, {
          opacity: 0
        });
      });
    }
  }
}
